import { useState, useEffect } from "react";
import MainAccordion from "../Accordion/MainAccordion";
import TrialCrc from "../PopUp/TrialCrc";
import { toast } from "react-toastify";
import { Box, Typography, Autocomplete, TextField, Chip } from "@mui/material";
import CustomButton from "../UI/CustomButton";

const TrialReviewersAccordion = ({
  role,
  trialDetails,
  allReviewers,
  onReviewerChange,
  AllReviewerData,
  setAllReviewers,
  handleBasicInfoUpdate,
  setReviewerChanged,
  reviewerChanged,
  setTrialDetails,
  seterrorMsg,
}) => {
  const [showModal, setShowModal] = useState("");
  const [isDisable, setIsDisable] = useState(true);

  const handleAddReviewer = () => {
    AllReviewerData();
  };

  useEffect(() => {
    if (trialDetails?.manual_reviewer_id === true) {
      setIsDisable(false);
      setTrialDetails((prevTrialDetails) => ({
        ...prevTrialDetails,
        reviewer_site_id_setting: {
          ...prevTrialDetails.reviewer_site_id_setting,
          setting_type: "Manual",
        },
      }));
    } else {
      setIsDisable(true);
      setTrialDetails((prevTrialDetails) => ({
        ...prevTrialDetails,
        reviewer_site_id_setting: {
          ...prevTrialDetails.reviewer_site_id_setting,
          setting_type: "Sequence",
        },
      }));
    }
  }, [trialDetails?.manual_reviewer_id]);

  const handleSave = () => {
    const isEmpty = trialDetails?.reviewers.some(
      (reviewer) => !reviewer?.site_number && !isDisable
    );
    if (isEmpty) {
      seterrorMsg("Please fill this field");
    } else {
      handleBasicInfoUpdate();
    }
  };

  return (
    <MainAccordion
      title="Reviewers"
      data={
        <Box sx={{ position: "relative", width: "100%", mb: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
            }}
          >
            {role !== "Investigator" && role !== "Inv_coordinator" && role !== "Reviewer" && (
              <Box sx={{ flex: 1 }}>
                <Box sx={{ mb: 1.5 }}>
                  <Autocomplete
                    fullWidth
                    multiple
                    id="reviewers-dropdown"
                    value={trialDetails.reviewers || []}
                    options={allReviewers}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    onChange={onReviewerChange}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return (
                          <Chip
                            key={key}
                            label={option.label}
                            size="small"
                            {...tagProps}
                            {...(option.isFixed && {
                              onDelete: undefined,
                            })}
                          />
                        );
                      })
                    }
                    renderInput={(params) => <TextField {...params} size="small" />}
                  />
                </Box>

                {showModal === true ? (
                  <TrialCrc
                    setShowModal={setShowModal}
                    toast={toast}
                    type="reviewer"
                    handleAddReviewer={handleAddReviewer}
                    trialDetails={trialDetails}
                    onReviewerChange={onReviewerChange}
                    setAllReviewers={setAllReviewers}
                    allReviewers={allReviewers}
                    setReviewerChanged={setReviewerChanged}
                  />
                ) : (
                  ""
                )}

                <CustomButton size="small" onClick={() => setShowModal(true)}>
                  Invite New Reviewer
                </CustomButton>
              </Box>
            )}

            <CustomButton
              size="small"
              id="reviewers-settings"
              onClick={() => handleSave()}
              disabled={!reviewerChanged}
            >
              Save
            </CustomButton>
          </Box>
        </Box>
      }
    />
  );
};
export default TrialReviewersAccordion;
